// Cookie (BFF) session: the API (/api), BMS (/bims/api) and the notification
// hub are same-origin relative paths behind the app's own proxy (vite in dev,
// nginx in prod) - no OIDC settings on the client at all.
export default {
  VITE_API_URL: import.meta.env.VITE_API_URL,
  VITE_API_CLIENT_URL: import.meta.env.VITE_API_CLIENT_URL,
  VITE_WS_API_URL: import.meta.env.VITE_WS_API_URL,
  VITE_MUI_LICENSE: import.meta.env.VITE_MUI_LICENSE,
  VITE_BMS_CLIENT_URL: import.meta.env.VITE_BMS_CLIENT_URL,
  VITE_HOUSEHOLD_URL: import.meta.env.VITE_HOUSEHOLD_URL,
  VITE_CRM_URL: import.meta.env.VITE_CRM_URL,
  VITE_DISTRIBUTION_ADMIN_URL: import.meta.env.VITE_DISTRIBUTION_ADMIN_URL,
};
